import { useViewerMaybe } from "@/authentication/ViewerProvider"
import LoadingScreen from "@/novus/components/loading-screen"
import { signInPath } from "@/novus/novus-paths"
import * as React from "react"
import { useNavigate } from "react-router-dom"
import UserProfile from "./components/UserProfile"

export const DashboardScreen = () => {
  const { viewer, loading } = useViewerMaybe()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!(loading || viewer)) {
      navigate(signInPath.pattern)
    }
  }, [navigate, viewer, loading])

  if (loading) {
    return <LoadingScreen />
  }

  if (viewer) {
    return <UserProfile />
  }

  return (
    <div className="p-2">
      <h1>Dashboard</h1>
    </div>
  )
}
